export default function runSetBluePage($rootScope, $window) {
  'ngInject';

  $rootScope.$on('$stateChangeSuccess', (event, toState) => {
    _.set($window, 'printos.blue.ui.page.id', toState.name);
  });
}
